import React from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'utils/toastUtils'
import { useAppDispatch } from 'helpers/store'
import { closeModal } from 'helpers/actions'
import { RemindersAction } from 'store/reminders/RemindersAction'
import SessionAction from 'store/session/SessionAction'
import UiFormModalShell from 'components/Forms/UiFormModalShell'
import ReminderForm from 'components/Reminders/forms/ReminderForm'

interface CreateReminderModalProps {
    onSuccess?: () => void
    reminder?: Partial<import('types/entities/Reminder').Reminder> & {
        model_id?: number
    }
    modelContext?: { id: number; name: string }
}

const CreateReminderModal: React.FC<CreateReminderModalProps> = ({ onSuccess, reminder, modelContext }) => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    const handleSubmit = async (data: any, shouldClose: boolean = false) => {
        try {
            await dispatch(RemindersAction.fetchCreateReminder(data))
            dispatch(SessionAction.fetchNotifications() as any)
            toast.success(t('Reminder created successfully'))
            onSuccess?.()
            if (shouldClose) {
                dispatch(closeModal())
            }
        } catch (e) {
            toast.error(t('Failed to create reminder'))
            throw e
        }
    }

    return (
        <UiFormModalShell className="CreateReminderModal" title={t('Create Reminder')} subtitle={t('Fill in the details for the new reminder')}>
            <div className="max-w-4xl mx-auto">
                <ReminderForm onSubmit={handleSubmit} reminder={reminder} modelContext={modelContext} />
            </div>
        </UiFormModalShell>
    )
}

export default CreateReminderModal
